<div class="container-menu animate__animated animate__fadeInDown">
  <nav
    class="relative flex flex-col lg:flex-row lg:items-center lg:justify-between p-4 transition-all duration-300 ease-in-out bg-menu text-white rounded-2xl">

    <!-- Logo + botón hamburger -->
    <div class="flex items-center justify-between w-full lg:w-auto">
      <div class="logo" [routerLink]="'./cartelera'">
        <img src="/assets/logo.png" alt="Logo de la empresa" />
      </div>
      <label class="lg:hidden hamburger">
        <input #menuCheckbox type="checkbox" (change)="toggleMenu()" />
        <svg viewBox="0 0 32 32">
          <path class="line line-top-bottom"
            d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22">
          </path>
          <path class="line" d="M7 16 27 16"></path>
        </svg>
      </label>
    </div>

    <div [ngClass]="{
        'max-h-[0] overflow-hidden': !isMenuOpen,
        'max-h-[800px] overflow-visible': isMenuOpen
      }"
      class="transition-all duration-300 ease-in-out lg:max-h-none lg:overflow-visible flex flex-col lg:flex-row lg:items-center lg:justify-between w-full">
      <ul class="flex flex-col lg:flex-row items-center justify-center lg:space-x-4 gap-6 mt-8 lg:mt-0 lg:gap-0 flex-1">
        <li>
          <a routerLinkActive="router-link-active" [routerLink]="'/cartelera'" class="btn mt-4 lg:m-0"
            (click)="closeMenu()">
            {{ "Cartelera" | uppercase }}
          </a>
        </li>
        <li>
          <a routerLinkActive="router-link-active" [routerLink]="'/confiteria'" class="btn mt-4 lg:m-0"
            (click)="closeMenu()">
            {{ "Confiteria" | uppercase }}
          </a>
        </li>
        <li>
          <a [routerLink]="'/proximamente'" routerLinkActive="router-link-active" class="btn mt-4 lg:m-0"
            (click)="closeMenu()">
            {{ "Próximamente" | uppercase }}
          </a>
        </li>
      </ul>

      <!-- Menú de Usuario -->
      <div class="mt-6 lg:mt-0 lg:ml-6">
        <app-user-menu></app-user-menu>
      </div>
    </div>
  </nav>
</div>